import { type Context } from './types';

export const DEFAULT_INPUT_TABLE = '__input';

export function emptyContext(): Context {
  return {
    variables: new Map(),
    variablesType: new Map(),
    input: new Map(),
    inputTable: DEFAULT_INPUT_TABLE,
    inputType: new Map(),
    refData: new Map(),
    refTypes: new Map(),
    refUniqueKeys: new Map(),
    useTypecheckStrictMode: false,
    useCustomColumns: false,
    useDateCoalesceOptimization: true,
  };
}
